import { render } from "./Signup.vue?vue&type=template&id=b59111da&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=b59111da&scoped=true&lang=css"

import exportComponent from "/home/alexeyza/git/chargd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59111da"]])

export default __exports__